import { useState } from "react";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Stack,
  Box,
  Typography,
} from "@mui/material";
import CodeMirror from "@uiw/react-codemirror";
import { python } from "@codemirror/lang-python";

import api from "./../api";

const DEFAULT_CODE = `def run(args):
    # write your generator; set result on sharedmem in worker(prompt, sharedmem)
    pass
`;

export default function NewGeneratorModal({ onClose }) {
  const [f, setF] = useState({
    name: "",
    media_type: "image",
    description: "",
    code: DEFAULT_CODE,
    venv_packages: "",
    vram_estimate_mb: 8192,
  });
  const [busy, setBusy] = useState(false);

  const up = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const create = async () => {
    setBusy(true);
    try {
      await api.post("/api/generators", {
        ...f,
        vram_estimate_mb: Number(f.vram_estimate_mb),
        venv_packages: f.venv_packages.split(/\s+/).filter(Boolean),
      });
      toast.success("Generator created");
      onClose(true);
    } catch {
      /* api wrapper toasts */
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onClose={() => onClose()} maxWidth="md" fullWidth>
      <DialogTitle>New generator</DialogTitle>
      <DialogContent dividers>
        <Stack direction="row" spacing={1.5} sx={{ mb: 1.5 }}>
          <TextField
            size="small"
            label="Name"
            placeholder="my_generator"
            value={f.name}
            onChange={up("name")}
            sx={{ flex: 1 }}
          />
          <TextField size="small" label="Type" select value={f.media_type} onChange={up("media_type")} sx={{ width: 150 }}>
            <MenuItem value="image">image</MenuItem>
            <MenuItem value="audio-stt">audio-stt</MenuItem>
          </TextField>
          <TextField
            size="small"
            label="VRAM est. (MB)"
            type="number"
            value={f.vram_estimate_mb}
            onChange={up("vram_estimate_mb")}
            sx={{ width: 150 }}
          />
        </Stack>

        <TextField
          fullWidth
          size="small"
          label="venv packages (space-separated; built with uv pip)"
          placeholder="torch diffusers transformers"
          value={f.venv_packages}
          onChange={up("venv_packages")}
          sx={{ mb: 1.5 }}
        />

        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
          code — worker(prompt, sharedmem) or run(args)
        </Typography>
        <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, overflow: "hidden" }}>
          <CodeMirror
            value={f.code}
            height="200px"
            extensions={[python()]}
            onChange={(v) => setF((s) => ({ ...s, code: v }))}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} color="inherit">
          Cancel
        </Button>
        <Button onClick={create} disabled={busy || !f.name} variant="contained">
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}
